import { Button, Col, Row, Modal, InputNumber, Radio, Space, Flex } from '@/UI'
import { useEffect, useState } from 'react'
import { api } from '../../tools/request'
import { notification, type RadioChangeEvent } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { formatPrice } from './utils'

const AMOUNTS = [10 ** 7, 10 ** 8, 10 ** 9]

export default function IncreaseCredit() {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [amount, setAmount] = useState()
  const [amountType, setAmountType] = useState<number | string>('custom')
  const [payLoading, setPayLoading] = useState(false)

  const showModal = () => setIsModalOpen(true)
  const handleCancel = () => setIsModalOpen(false)
  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleSelectAmountType = (e: RadioChangeEvent) => {
    const { value } = e.target
    setAmountType(value)
    if (value !== 'custom') {
      setAmount(value)
    }
  }

  useEffect(() => {
    api('/wallet/find-by-currency?currencyCode=IRR')
      .then(({ data }) => {
        data = { ...data, effectiveAmount: Math.ceil(data.effectiveAmount) }
        setData(data)
        setAmount(data.effectiveAmount < 0 ? Math.abs(data.effectiveAmount) : 0)
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false))
  }, [])

  function pay() {
    setPayLoading(true)
    api('/charge-transaction/request-payment', {
      method: 'POST',
      data: {
        r2WalletId: data.r2WalletId,
        amount
      }
    })
      .then(({ data }) => {
        if (
          data.paymentResult === 'OK' ||
          data.paymentResult === 'SUCCESSFUL'
        ) {
          window.location.href = data.redirectUrl
        } else {
          notification.error({ message: 'مشکل در هدایت به صفحه پرداخت.' })
        }
      })
      .finally(() => setPayLoading(false))
  }

  if (loading || error) return ''

  return (
    <div>
      <Row
        gutter={16}
        align='middle'
        style={{
          padding: '14px 38px'
        }}
      >
        <Col style={{ fontWeight: 600 }}>اعتبار شما:</Col>
        <Col
          style={{
            fontWeight: 600,
            fontSize: '1rem',
            color: data.effectiveAmount > 0 ? '#202D73' : 'red',
            direction: 'ltr'
          }}
        >
          {data.effectiveAmount > 0 ? '+' : '-'}
          {formatPrice(data.effectiveAmount)}
        </Col>
        <Col>ریال</Col>
        <Col>
          <Button type='primary' size='large' onClick={showModal}>
            افزایش اعتبار
          </Button>
        </Col>
      </Row>
      <Modal
        width={450}
        title={<Flex justify='center'>افزایش اعتبار</Flex>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer=''
      >
        <Radio.Group
          onChange={handleSelectAmountType}
          value={amountType}
          size='large'
          style={{ margin: '1rem' }}
        >
          <Space direction='vertical' size='large'>
            {AMOUNTS.map((el) => (
              <Radio value={el}>{formatPrice(el)} ریال</Radio>
            ))}
            <Radio value={'custom'}>مبلغ دلخواه</Radio>
          </Space>
        </Radio.Group>
        {amountType === 'custom' && (
          <Flex vertical>
            <InputNumber
              size='large'
              suffix='ریال'
              defaultValue={amount}
              style={{ width: '100%' }}
              onChange={setAmount}
              min={200000}
              formatter={(value) =>
                `${value}`
                  .replace(/\D/g, '')
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              parser={(value) =>
                value?.replace(/\$\s?|(,*)/g, '') as unknown as number
              }
            />
            <div
              style={{
                textAlign: 'left',
                margin: '6px',
                fontSize: '12px',
                color: '#808080'
              }}
            >
              مبلغ مورد نظر را به ریال وارد کنید
            </div>
          </Flex>
        )}
        <Flex gap={16} style={{ marginTop: '2.5rem' }}>
          <Button
            size='large'
            icon={<CloseOutlined />}
            danger
            onClick={handleCancel}
          >
            انصراف
          </Button>
          <Button
            size='large'
            icon={<PlusOutlined />}
            block
            type='primary'
            style={{ backgroundColor: 'green' }}
            onClick={pay}
            disabled={payLoading}
            loading={payLoading}
          >
            پرداخت {formatPrice(amount / 10)} تومان
          </Button>
        </Flex>
      </Modal>
    </div>
  )
}
